import { Outlet } from "react-router-dom";
import { Header, Sidebar } from "../../../ui";

const DefaultLayout = () => {
  return (
    <div className="flex h-screen w-full">
      <Sidebar />
      <div className="md:ml-56 h-full w-full">
        <Header />
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
